import React from 'react';

import NoSubscriptionPM from '../../custom/-APP_TARGET/mods/modal/NoSubscriptionPM';

function CustomNoSubscription({ cancelClick }) {
  return <NoSubscriptionPM cancelClick={cancelClick}  />
}

export default CustomNoSubscription;
